import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { Link } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

const useStyles = makeStyles()(theme => ({
  clearFiltersButton: {
    color: theme.palette.text.primary,
    fontSize: '14px',
    cursor: 'pointer',
    alignSelf: 'center',
  },
}))

export const ClearFiltersButton: React.VFC<{ onClick: () => void }> = ({ onClick }) => {
  const { t } = useCustomTranslation()
  const { classes } = useStyles()

  return (
    <Link underline="none" className={classes.clearFiltersButton} onClick={onClick}>
      {t('filter.clearAllButtonText')}
    </Link>
  )
}
